import { css } from '@emotion/react'
import cn from 'classnames'
import Link from 'redux-first-router-link'
import { styles as buttonStyles } from '@groovehq/internal-design-system/lib/styles/elements/Button/button.styles'
import { toInboxesPage } from 'subapps/settings/actions/redirect'
import Label from '../Label'
import Row from '../IndentedRow'
import Dropdown from './Dropdown'

const flexStyle = css`
  flex: 1 1 100%;

  & > * {
    align-items: baseline;
  }
`

const FromRow = ({
  className,
  isLogging,
  mailbox,
  mailboxId,
  mailboxes,
  onMailboxClick,
  children,
}) => {
  let currentMailbox = mailbox
  if (mailboxId) currentMailbox = mailboxes.find(m => m.id === mailboxId)
  return (
    <div className={cn('grui flex', className)}>
      {children}
      <Row css={flexStyle}>
        <Label>
          {isLogging ? app.t('Mailbox') : 'From'}
          :
        </Label>
        {mailboxes.length === 0 ? (
          <Link
            className="grui ml-3"
            as="button"
            type="button"
            css={buttonStyles.link}
            to={toInboxesPage}
            shouldDispatch
          >
            Please add {app.t('mailbox_with_article')} first
          </Link>
        ) : (
          <Dropdown
            mailbox={currentMailbox}
            mailboxes={mailboxes}
            onClick={onMailboxClick}
            className="grui ml-3"
          />
        )}
      </Row>
    </div>
  )
}

export default FromRow
